import expressionStore from '../store/expressionStore';
import Emoji from '../store/schema/Emoji';
import { isBrowserIE } from 'owa-user-agent/lib/userAgent';

/**
 * Given an emoji, applies skin tone modifier and returns resulting unicode code point after
 * applying a skintone to the base character of the emoji. This is because some emojis are
 * representated as equations of existing emojis (eg. 👨‍💼 = 👨+💼), and skin tone must be applied to the first
 * emoji, the person, in this case.
 *
 * Expects that emojis passed in are able to have skin tone applied to them in this way.
 *
 * ie. 🤷 --> 🤷 + skintone =  🤷🏾‍
 * ie. 👨‍💼 = 👨+💼 --> 👨 + skintone + 💼 --> 👨🏾‍💼
 */
export default function getEmojiCodePointWithSkinTone(emoji: Emoji): string {
    // Skin tone modifiers must be added after the first codepoint for an emoji (via unicode standards)
    if (!isBrowserIE() && expressionStore.selectedSkinTone && emoji.hasSkinTone) {
        let baseEmojiChar = emoji.codePoint.charAt(0) + emoji.codePoint.charAt(1);
        let str = emoji.codePoint;
        return str.replace(baseEmojiChar, baseEmojiChar + expressionStore.selectedSkinTone);
    } else {
        return emoji.codePoint;
    }
}
